import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import { dequal } from 'dequal';
import { compare, lines } from 'uvu/diff';
function dedent(str) {
  str = str.replace(/\r?\n/g, '\n');
  var arr = str.match(/^[ \t]*(?=\S)/gm);
  var i = 0,
    min = 1 / 0,
    len = (arr || []).length;
  for (; i < len; i++) min = Math.min(min, arr[i].length);
  return len && min ? str.replace(new RegExp("^[ \\t]{".concat(min, "}"), 'gm'), '') : str;
}
export var Assertion = /*#__PURE__*/function (_Error) {
  function Assertion() {
    var _this;
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Assertion);
    _this = _callSuper(this, Assertion, [opts.message]);
    _this.name = 'Assertion';
    _this.code = 'ERR_ASSERTION';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, _this.constructor);
    }
    _this.details = opts.details || false;
    _this.generated = !!opts.generated;
    _this.operator = opts.operator;
    _this.expects = opts.expects;
    _this.actual = opts.actual;
    return _this;
  }
  _inherits(Assertion, _Error);
  return _createClass(Assertion);
}(/*#__PURE__*/_wrapNativeSuper(Error));
function assert(bool, actual, expects, operator, detailer, backup, msg) {
  if (bool) return;
  var message = msg || backup;
  if (msg instanceof Error) throw msg;
  var details = detailer && detailer(actual, expects);
  throw new Assertion({
    actual: actual,
    expects: expects,
    operator: operator,
    message: message,
    details: details,
    generated: !msg
  });
}
export function ok(val, msg) {
  assert(!!val, false, true, 'ok', false, 'Expected value to be truthy', msg);
}
export function is(val, exp, msg) {
  assert(val === exp, val, exp, 'is', compare, 'Expected values to be strictly equal:', msg);
}
export function equal(val, exp, msg) {
  assert(dequal(val, exp), val, exp, 'equal', compare, 'Expected values to be deeply equal:', msg);
}
export function unreachable(msg) {
  assert(false, true, false, 'unreachable', false, 'Expected not to be reached!', msg);
}
export function type(val, exp, msg) {
  var tmp = typeof val;
  assert(tmp === exp, tmp, exp, 'type', false, "Expected \"".concat(tmp, "\" to be \"").concat(exp, "\""), msg);
}
export function instance(val, exp, msg) {
  var name = '`' + (exp.name || exp.constructor.name) + '`';
  assert(val instanceof exp, val, exp, 'instance', false, "Expected value to be an instance of ".concat(name), msg);
}
export function match(val, exp, msg) {
  if (typeof exp === 'string') {
    assert(val.includes(exp), val, exp, 'match', false, "Expected value to include \"".concat(exp, "\" substring"), msg);
  } else {
    assert(exp.test(val), val, exp, 'match', false, "Expected value to match `".concat(String(exp), "` pattern"), msg);
  }
}
export function snapshot(val, exp, msg) {
  val = dedent(val);
  exp = dedent(exp);
  assert(val === exp, val, exp, 'snapshot', lines, 'Expected value to match snapshot:', msg);
}
var lineNums = function lineNums(x, y) {
  return lines(x, y, 1);
};
export function fixture(val, exp, msg) {
  val = dedent(val);
  exp = dedent(exp);
  assert(val === exp, val, exp, 'fixture', lineNums, 'Expected value to match fixture:', msg);
}
function _throws(blk, exp, msg) {
  if (!msg && typeof exp === 'string') {
    msg = exp;
    exp = null;
  }
  try {
    blk();
    assert(false, false, true, 'throws', false, 'Expected function to throw', msg);
  } catch (err) {
    if (err instanceof Assertion) throw err;
    if (typeof exp === 'function') {
      assert(exp(err), false, true, 'throws', false, 'Expected function to throw matching exception', msg);
    } else if (exp instanceof RegExp) {
      assert(exp.test(err.message), false, true, 'throws', false, "Expected function to throw exception matching `".concat(String(exp), "` pattern"), msg);
    }
  }
}

// ---
export { _throws as throws };
export function not(val, msg) {
  assert(!val, true, false, 'not', false, 'Expected value to be falsey', msg);
}
not.ok = not;
is.not = function (val, exp, msg) {
  assert(val !== exp, val, exp, 'is.not', false, 'Expected values not to be strictly equal', msg);
};
not.equal = function (val, exp, msg) {
  assert(!dequal(val, exp), val, exp, 'not.equal', false, 'Expected values not to be deeply equal', msg);
};
not.type = function (val, exp, msg) {
  var tmp = typeof val;
  assert(tmp !== exp, tmp, exp, 'not.type', false, "Expected \"".concat(tmp, "\" not to be \"").concat(exp, "\""), msg);
};
not.instance = function (val, exp, msg) {
  var name = '`' + (exp.name || exp.constructor.name) + '`';
  assert(!(val instanceof exp), val, exp, 'not.instance', false, "Expected value not to be an instance of ".concat(name), msg);
};
not.snapshot = function (val, exp, msg) {
  val = dedent(val);
  exp = dedent(exp);
  assert(val !== exp, val, exp, 'not.snapshot', false, 'Expected value not to match snapshot', msg);
};
not.fixture = function (val, exp, msg) {
  val = dedent(val);
  exp = dedent(exp);
  assert(val !== exp, val, exp, 'not.fixture', false, 'Expected value not to match fixture', msg);
};
not.match = function (val, exp, msg) {
  if (typeof exp === 'string') {
    assert(!val.includes(exp), val, exp, 'not.match', false, "Expected value not to include \"".concat(exp, "\" substring"), msg);
  } else {
    assert(!exp.test(val), val, exp, 'not.match', false, "Expected value not to match `".concat(String(exp), "` pattern"), msg);
  }
};
not["throws"] = function (blk, exp, msg) {
  if (!msg && typeof exp === 'string') {
    msg = exp;
    exp = null;
  }
  try {
    blk();
  } catch (err) {
    if (typeof exp === 'function') {
      assert(!exp(err), true, false, 'not.throws', false, 'Expected function not to throw matching exception', msg);
    } else if (exp instanceof RegExp) {
      assert(!exp.test(err.message), true, false, 'not.throws', false, "Expected function not to throw exception matching `".concat(String(exp), "` pattern"), msg);
    } else if (!exp) {
      assert(false, true, false, 'not.throws', false, 'Expected function not to throw', msg);
    }
  }
};